import React from "react";
import { render } from "react-dom";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";

function Footer() {
  return (
    <div className="col-12">
      <div className="row">
        <div className="col-12 footer-column text-center">
          <Link
            to="/globaldashboard"
            style={{ "font-family": "Arimo, sans-serif" }}
          >
            <br />
            <i className="fa fa-angle-left"></i> &nbsp; Back to Dashboard &nbsp;
            <i className="fa fa-angle-right"></i>
          </Link>
        </div>
        <div className="col-12 footer-column">
          <p className="highlightTag">
            <span>
              {" "}
              <i className="fa fa-heart-o"></i> &nbsp;GlobalCovidDataTracker
            </span>
          </p>
        </div>
        <div className="col-12 footer-column alert-column">
          <p>We stand with everyone fighting on the frontlines</p>
          <p>
            Created With &nbsp;<i className="fa fa-heart-o"></i> By Subhajit Das
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
